import React, { useMemo, useEffect, useState } from 'react';
import { Card, Form, InputNumber, Button, Typography, message, Spin } from 'antd';
import client from '../../api/client';

const defaultSettings = {
    lowRecoveryWarning: 60,
    lowRecoveryCritical: 55,
    netLossFloor: 5000,
    netLossPercent: 2,
};

const NotificationSettings = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(true);

    const initialValues = useMemo(() => defaultSettings, []);

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const { data } = await client.get('/admin/notification-settings');
                form.setFieldsValue({
                    lowRecoveryWarning: data.low_recovery_warning ?? defaultSettings.lowRecoveryWarning,
                    lowRecoveryCritical: data.low_recovery_critical ?? defaultSettings.lowRecoveryCritical,
                    netLossFloor: data.net_loss_floor ?? defaultSettings.netLossFloor,
                    netLossPercent: data.net_loss_percent ?? defaultSettings.netLossPercent,
                });
            } catch (error) {
                message.error('Failed to load notification settings');
                form.setFieldsValue(initialValues);
            } finally {
                setLoading(false);
            }
        };

        fetchSettings();
    }, [form, initialValues]);

    const saveSettings = async (values) => {
        const payload = {
            low_recovery_warning: Number(values.lowRecoveryWarning),
            low_recovery_critical: Number(values.lowRecoveryCritical),
            net_loss_floor: Number(values.netLossFloor),
            net_loss_percent: Number(values.netLossPercent),
        };
        try {
            await client.put('/admin/notification-settings', payload);
            message.success('Notification thresholds updated');
        } catch (error) {
            message.error('Failed to update notification settings');
        }
    };

    return (
        <div style={{ padding: 24 }}>
            <Card className="premium-card" bodyStyle={{ padding: 24, maxWidth: 560 }}>
                <Typography.Title level={4} style={{ marginTop: 0 }}>Notification Thresholds</Typography.Title>
                <Typography.Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
                    Controls alerts for low recovery and net loss. Low stock uses each item reorder level.
                </Typography.Text>
                <Spin spinning={loading}>
                    <Form
                        form={form}
                        layout="vertical"
                        initialValues={initialValues}
                        onFinish={saveSettings}
                    >
                        <Form.Item
                            label="Recovery warning (%)"
                            name="lowRecoveryWarning"
                            rules={[{ required: true }]}
                        >
                            <InputNumber min={0} max={100} style={{ width: '100%' }} />
                        </Form.Item>
                        <Form.Item
                            label="Recovery critical (%)"
                            name="lowRecoveryCritical"
                            rules={[{ required: true }]}
                        >
                            <InputNumber min={0} max={100} style={{ width: '100%' }} />
                        </Form.Item>
                        <Form.Item
                            label="Net loss floor (amount)"
                            name="netLossFloor"
                            rules={[{ required: true }]}
                        >
                            <InputNumber min={0} style={{ width: '100%' }} />
                        </Form.Item>
                        <Form.Item
                            label="Net loss percent of monthly sales (%)"
                            name="netLossPercent"
                            rules={[{ required: true }]}
                        >
                            <InputNumber min={0} max={100} style={{ width: '100%' }} />
                        </Form.Item>
                        <Button type="primary" htmlType="submit">
                            Save Settings
                        </Button>
                    </Form>
                </Spin>
            </Card>
        </div>
    );
};

export default NotificationSettings;


